import { useContext, useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import TransactionPinModal from "../components/TransactionPinModal";

const ProtectedRoute = () => {
  const { currentUser, logout, showPinModal } = useContext(AuthContext);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const payload = JSON.parse(atob(token.split(".")[1]));
      const expiry = payload.exp * 1000;
      if (Date.now() > expiry) {
        logout();
      }
    }
  }, [currentUser, logout]);

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div style={{ position: "relative" }}>
      {showPinModal && <TransactionPinModal />}
      <Outlet />
    </div>
  );
};

export default ProtectedRoute;
